import { IntentSentence } from ".";
import { v4 as uuidv4 } from 'uuid';

export type IntentConfig = {
    use_intent_threshold?: boolean;
    intent_threshold?: number
}

export const EntityValueSelectionTypes = ["keyword", "synonym", "mapping_value", "nothing"] as const;
export type EntityValueSelectionType = typeof EntityValueSelectionTypes[number];

export type SlotForm = {
    key: string;
    required: boolean;
    is_list: boolean;
    parameter: string;
    entity_tags: string[];
    entity_value_selection: EntityValueSelectionType;
    default: string;
}
export const emptySlot = {
    key: uuidv4(),
    required: false,
    is_list: false,
    parameter: '',
    entity_tags: [] as string[],
    entity_value_selection: 'keyword' as EntityValueSelectionType,
    default: ''
};

export type Intent = {
    id: string;
    agent_id: number;
    domain_id: number;
    skill_id: number;
    active: boolean;
    name: string;
    sentences: IntentSentence[];
    token: string;
    answers?: string[];
    slot_info?: SlotForm[];
    config?: IntentConfig;
    created_at: string;
    updated_at?: string;
    deleted_at?: string;
}
export type IntentCreate = {
    name: string;
}
export type IntentUpdate = {
    name?: string;
    slot_info?: SlotForm[];
    answers?: string[];
    active?: boolean;
    config?: IntentConfig;
}
export type IntentTransfer = {
    intent_ids: string[];
    skill_id: number;
}

export type SimpleIntent = {
    id: string;
    name: string;
    active: boolean;
}
